import { i18nKeys } from "./i18n";

export type literals = { [key in i18nKeys]: string };

const t: literals = {
  emailPlaceholder: "Email",
  password: "Password",
  dontKnowPassword: "Forgot password?",
  signInGreetingHeader: "Sign in",
  signInGreetingDescription: "Enter your details to sign in.",
  signIn: "Sign in",
  landingLinkText: "What is TraceAir?",
  emailForRecovery: "Email address",
  sendRecoveryEmail: "Send reset link",
  sendRecoveryEmailAgain: "Send again",
  requestPasswordRecoveryGreeting: "Reset your password",
  requestPasswordRecoveryGreeting2:
    "Enter your email address and we’ll send you a link to reset your password.",
  requestPasswordRecoverySent: "Email Sent",
  requestPasswordRecoverySuccessTitle: "Confirm your email",
  requestPasswordRecoverySuccessSubtitle1: "We sent you an email to ",
  requestPasswordRecoverySuccessSubtitle2:
    " that contains the link to sign you in.",
  ifNeedHelp: "Still having trouble?",
  contactUs: "Contact us",

  cancelRecover: "Back",
  setANewPassword: "Set password",
  setPasswordAndSignIn: "Save and Sign in",
  nowSetANewPassword: "Set password",
  changePasswordGreetingTitle: "Let’s reset your password",
  changePasswordGreetingDiscription:
    "Choose a secure password to protect your account.",
  confirmPassword: "Confirm password",
  passwordsDoNotMatchTitle: "Passwords don’t match",
  passwordsDoNotMatchSubtitle: "Passwords don’t match",

  invalidCredentialsErrorTitle: "Incorrect email or password",
  invalidCredentialsErrorSubtitle: "Please try again.",
  weakPassword: "Minimum 8 characters",
  unknownError: "We’re sorry!",
  termsOfUseTitle: "By continuing, you agree to TraceAir’s Terms of Use.",
  termsOfUseDescription: "Please review the full document below.",
  acceptAndContinue: "Accept and continue",
  decline: "Decline",
  emailRequired: "Please enter your email",
  incorrectEmail: "Сheck that your email is entered correctly",
  passwordRequired: "Please enter your password",
  unknownErrorSubTitle1:
    "We are experiencing technical <br/>difficulties. Please try again in a <br />moment or ",
  unknownErrorSubTitle2: "contact us",
  unknownErrorSubTitle3: " to get help.",
  tooManyAttemptsTitle: "Too many attempts",
  tooManyAttemptsSubtitle: "Please wait {s} and try again."
};

export default t;
